import { render, staticRenderFns } from "./staffInfo.vue?vue&type=template&id=81458992&scoped=true"
import script from "./staffInfo.vue?vue&type=script&lang=js"
export * from "./staffInfo.vue?vue&type=script&lang=js"
import style0 from "./staffInfo.vue?vue&type=style&index=0&id=81458992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81458992",
  null
  
)

export default component.exports